/**
 * Check if the `searchCode` exists in the `codings` array
 */
export const isCodingInList = (searchCode: string, codings?: fhir4.Coding[]): boolean => {
  const foundCode = codings?.find(c => c.code === searchCode);
  return !!foundCode;
};
